import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { SINGLETON_ID } from '@cli-constants/generators.js'
import { sampleSchemaOutputValue } from './sample-schema-output-value.js'
export function sampleSingleOutputValue(field: SchemaField): unknown {
  if (field.name === 'id') return SINGLETON_ID

  return sampleSchemaOutputValue(field)
}
